unit CommunicationsListPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists;

type
  TCommunicationsListForm = class(TBaseListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetClientId: TIntegerField;
    MainDatasetContactMethod: TStringField;
    MainDatasetContactAddress: TStringField;
    MainDatasetSubject: TStringField;
    MainDatasetBody: TStringField;
    MainDatasetCommunicationType: TStringField;
    MainDatasetSentAt: TDateTimeField;
    MainDatasetStatus: TStringField;
    MainDatasetStatusMessage: TStringField;
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }

  protected
    procedure PrepareForm; override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  CommunicationsListForm: TCommunicationsListForm;

implementation

{$R *.dfm}

uses
  MainDataModule;

procedure TCommunicationsListForm.PrepareForm;
begin
  FIdField := 'Id';

  MainDataset.Connection := MainData.DataConnection;

  AddButton.Visible := False;

end;

procedure TCommunicationsListForm.WebFormShow(Sender: TObject);
begin
  inherited;
  cbPageSizeChange(cbPageSize);

end;

procedure TCommunicationsListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetClientId := TIntegerField.Create(Self);
  MainDatasetContactMethod := TStringField.Create(Self);
  MainDatasetContactAddress := TStringField.Create(Self);
  MainDatasetSubject := TStringField.Create(Self);
  MainDatasetBody := TStringField.Create(Self);
  MainDatasetCommunicationType := TStringField.Create(Self);
  MainDatasetSentAt := TDateTimeField.Create(Self);
  MainDatasetStatus := TStringField.Create(Self);
  MainDatasetStatusMessage := TStringField.Create(Self);

  DataTable.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetClientId.BeforeLoadDFMValues;
  MainDatasetContactMethod.BeforeLoadDFMValues;
  MainDatasetContactAddress.BeforeLoadDFMValues;
  MainDatasetSubject.BeforeLoadDFMValues;
  MainDatasetBody.BeforeLoadDFMValues;
  MainDatasetCommunicationType.BeforeLoadDFMValues;
  MainDatasetSentAt.BeforeLoadDFMValues;
  MainDatasetStatus.BeforeLoadDFMValues;
  MainDatasetStatusMessage.BeforeLoadDFMValues;
  try
    Name := 'CommunicationsListForm';
    Caption := 'Communications';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ContactAddress';
      Title := 'Sent To';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ContactMethod';
      Title := 'Contact Method';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'SentAt';
      Title := 'Sent';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Status';
      Title := 'Status';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'StatusMessage';
      Title := 'Status Message';
    end;
    AddButton.Visible := False;
    MainDataset.EntitySetName := 'CommunicationLog';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetId.Required := True;
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetDateAdded.Required := True;
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetAddedBy.Required := True;
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetClientId.SetParentComponent(MainDataset);
    MainDatasetClientId.Name := 'MainDatasetClientId';
    MainDatasetClientId.FieldName := 'ClientId';
    MainDatasetClientId.Required := True;
    MainDatasetContactMethod.SetParentComponent(MainDataset);
    MainDatasetContactMethod.Name := 'MainDatasetContactMethod';
    MainDatasetContactMethod.FieldName := 'ContactMethod';
    MainDatasetContactMethod.Required := True;
    MainDatasetContactMethod.Size := 255;
    MainDatasetContactAddress.SetParentComponent(MainDataset);
    MainDatasetContactAddress.Name := 'MainDatasetContactAddress';
    MainDatasetContactAddress.FieldName := 'ContactAddress';
    MainDatasetContactAddress.Required := True;
    MainDatasetContactAddress.Size := 255;
    MainDatasetSubject.SetParentComponent(MainDataset);
    MainDatasetSubject.Name := 'MainDatasetSubject';
    MainDatasetSubject.FieldName := 'Subject';
    MainDatasetSubject.Required := True;
    MainDatasetSubject.Size := 255;
    MainDatasetBody.SetParentComponent(MainDataset);
    MainDatasetBody.Name := 'MainDatasetBody';
    MainDatasetBody.FieldName := 'Body';
    MainDatasetBody.Size := 5000;
    MainDatasetCommunicationType.SetParentComponent(MainDataset);
    MainDatasetCommunicationType.Name := 'MainDatasetCommunicationType';
    MainDatasetCommunicationType.FieldName := 'CommunicationType';
    MainDatasetCommunicationType.Required := True;
    MainDatasetCommunicationType.Size := 255;
    MainDatasetSentAt.SetParentComponent(MainDataset);
    MainDatasetSentAt.Name := 'MainDatasetSentAt';
    MainDatasetSentAt.FieldName := 'SentAt';
    MainDatasetSentAt.Required := True;
    MainDatasetStatus.SetParentComponent(MainDataset);
    MainDatasetStatus.Name := 'MainDatasetStatus';
    MainDatasetStatus.FieldName := 'Status';
    MainDatasetStatus.Required := True;
    MainDatasetStatus.Size := 255;
    MainDatasetStatusMessage.SetParentComponent(MainDataset);
    MainDatasetStatusMessage.Name := 'MainDatasetStatusMessage';
    MainDatasetStatusMessage.FieldName := 'StatusMessage';
    MainDatasetStatusMessage.Required := True;
    MainDatasetStatusMessage.Size := 255;
  finally
    DataTable.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetClientId.AfterLoadDFMValues;
    MainDatasetContactMethod.AfterLoadDFMValues;
    MainDatasetContactAddress.AfterLoadDFMValues;
    MainDatasetSubject.AfterLoadDFMValues;
    MainDatasetBody.AfterLoadDFMValues;
    MainDatasetCommunicationType.AfterLoadDFMValues;
    MainDatasetSentAt.AfterLoadDFMValues;
    MainDatasetStatus.AfterLoadDFMValues;
    MainDatasetStatusMessage.AfterLoadDFMValues;
  end;
end;

end.